//
// Modal
//
import Cookies from 'js-cookie'

$(function() {
    if($('.auto-modal').length == 1) {
        var nodeName = $('.auto-modal').attr('id');

        if (Cookies.get('auto-modal-' + nodeName) == null) {
            Cookies.set('auto-modal-' + nodeName, 1, {expires: 365});
            $('.auto-modal').modal('show');
        }
    }
});




// WEBPACK FOOTER //
// ./Private/Fusion/Component/Atom/Modal/Modal.js